<template>
    <div>
        <div class="table-header row">
            <div>
                状态
            </div>
            <div>
                路由器品牌
            </div>
            <div>
                IP获取方式/连接地址
            </div>
            <div>操作</div>
        </div>
        <div class="table-body">
            <div class="row" v-for="(item, index) in listData" :key="index">
                <!-- 状态 -->
                <div>
                    <img style="position:relative;top:4px;"
                    src=@/assets/img/icon/u1409.png />
                </div>
                <!-- 路由器品牌 -->
                <div>
                    <router-tag-hover-down :tag="item" class="one-line">
                        <div slot="hoverBtn">
                            <div>
                                <p v-text="item.tradeMarkName"></p>
                            </div>
                        </div>
                    </router-tag-hover-down>
                </div>
                <!-- IP -->
                <div class="ip-name">
                    <p>
                        <span v-if="item.status == 0">手动获取</span>
                        <span v-if="item.status == 1">自动获取</span>
                    </p>
                    <p>
                        <span v-text="item.ip"></span>
                    </p>
                </div>
                <div class="operate">
                    <a
                        href="#"
                        @click.prevent="
                            $WhdsRemoteProtocal.routerAutoLogin(item)
                        "
                        >免密登录</a
                    >
                    <word-down class="more-btn" :content="'更多'">
                        <div slot="down">
                            <div class="drop-row" @click="editRouter(item)">
                                <span>修改路由远程</span>
                            </div>
                            <div class="drop-row" @click="showDelete(item)">
                                <span>删除路由远程</span>
                            </div>
                        </div>
                    </word-down>
                </div>
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                :nodata="tableList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
    </div>
</template>

<script>
// 更多悬浮
import WordDown from "_c/dropdown/wordDown";
import RouterTagHoverDown from "_sc/routerTagHoverDown";
import NoData from "_c/noData/noData";

import { deleteRouter } from "@/requests/bar";

export default {
    name: "tableData",
    components: {
        WordDown,
        RouterTagHoverDown,
        NoData
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            listData: []
        };
    },
    watch: {
        tableList() {
            this.listData = this.tableList;
        }
    },
    methods: {
        async editRouter(item) {
            let res = await window.$modal.setRouterRemoteModal.show(item, 1);
            if (res) {
                this.$emit("refresh");
            }
        },
        showDelete({ routerId }) {
            window.$Message.show({
                title: "是否删除",
                type: "success",
                msg: "你确认删除路由器吗",
                cancleBtn: true,
                confirmFn: () => {
                    this.deleteRouter({ routerId });
                    window.$Message.hide();
                }
            });
        },
        async deleteRouter({ routerId }) {
            let res = await deleteRouter({ routerId });
            if (res.code == 200) {
                this.$emit("refresh");
                window.$Message.show({
                    title: "提示",
                    type: "success",
                    msg: res.msg,
                    confirmFn: () => {
                        window.$Message.hide();
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;
        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
            overflow: visible;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }
    .more-btn {
        margin-left: 0;
    }

    > div:nth-child(1) {
        width: 10%;
        text-indent: 10px;
        input {
            position: relative;
            top: 2px;
        }
    }
    > div:nth-child(2) {
        width: 24%;
    }
    > div:nth-child(3) {
        width: 24%;
    }
    > div:nth-child(4) {
        width: 42%;
    }
}

.table-header {
    > div {
        height: 30px;
        line-height: 30px;
    }
}

.bar-name,
.computer-name,
.ip-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.computer-name {
    p:nth-child(1) {
        color: $blue-1;
    }
}

.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}
.gray-color {
    color: $gray-word;
}
</style>
